import { Checkbox } from '@mui/material';
import { Prompt } from '../../../models/Prompt.model';
import { DarkEditIcon, DeleteIcon } from '../../Icons/CommonIcons';
import { GamePack } from '@/API';

interface PromptCardProps {
  prompt: Prompt & { associatedGamePacks?: GamePack[] };
  subText?: string;
  onClick?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  hideButtons?: boolean;
  hideGamePacks?: boolean;
  isHighlighted?: boolean;
  showToggle?: boolean;
}

const formatGamePacks = (gamePacks: GamePack[]) => {
  if (!gamePacks || gamePacks.length === 0) {
    return 'N/A';
  }

  if (gamePacks.length > 3) {
    return `${gamePacks[0]?.name}, ${gamePacks[1]?.name}, and ${gamePacks.length - 2} others`;
  } else {
    return gamePacks
      .map((gamePack) => gamePack?.name)
      .filter((name) => name !== undefined && name.length > 0)
      .join(', ');
  }
};

export function PromptCard({
  prompt,
  subText,
  onEdit,
  onDelete,
  hideButtons,
  hideGamePacks,
  isHighlighted,
  onClick,
  showToggle
}: PromptCardProps) {
  return (
    <div
      className={`flex w-full bg-gray-100 card p-[24px] rounded-[20px] border-2 hover:border-clementine-dark group mb-[16px] hover:cursor-pointer prompt-card ${
        isHighlighted === true ? 'border-black-dark bg-orange-100' : ''
      }`}
      onClick={() => onClick?.()}
    >
      <div className="flex flex-col grow w-full h-full">
        <div className="flex flex-row items-center justify-between mb-[8px] h-34">
          <div className="flex flex-col">
            <h2>{prompt.text}</h2>
            {subText ? <p className="italic text-slate-500">{subText}</p> : <></>}
          </div>
          {showToggle === true ? (
            <div className="flex items-center">
              <Checkbox
                checked={isHighlighted === true}
                sx={{
                  color: '#D3D3D3',
                  '&.Mui-checked': {
                    color: '#F58C29'
                  }
                }}
                disabled={true}
              />
            </div>
          ) : (
            <></>
          )}
          {hideButtons === true ? (
            <></>
          ) : (
            <div className="flex flex-row items-center hidden group-hover:flex">
              <span
                className="hover:cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit?.();
                }}
              >
                <DarkEditIcon />
              </span>
              <span
                className="ml-[16px] hover:cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete?.();
                }}
              >
                <DeleteIcon />
              </span>
            </div>
          )}
        </div>
        {hideGamePacks === true ? (
          <></>
        ) : (
          <>
            <div className="border-t-2  border-gray-300 my-8"></div>
            <p className="flex card-body h-full grow">
              Game Packs: {formatGamePacks(prompt.associatedGamePacks ?? [])}
            </p>
          </>
        )}
      </div>
    </div>
  );
}
